export default "__VITE_ASSET__ByySvmRG__"